import { useCallback } from 'react';
import { useRouter } from 'next/navigation';
import { signOut } from '@/lib/auth-client';
import { useResetState } from './useResetState';

/**
 * Hook that provides a logout function with complete state cleanup
 *
 * Handles:
 * - React Query cache clearing (conversations, messages, etc.)
 * - Jotai atom state reset (conversation IDs, streaming state)
 * - Authentication signout
 * - Navigation to login page
 */
export function useLogout() {
	const router = useRouter();
	const resetState = useResetState();

	return useCallback(async () => {
		// 1. Clear all client state
		resetState();

		// 2. Sign out from auth
		await signOut();

		// 3. Navigate to login page and refresh
		router.push('/login');
		router.refresh();
	}, [router, resetState]);
}
